"use client";

import { Flex, Heading, Text, useColorModeValue } from "@chakra-ui/react";

interface NoDataFallbackProps {
  title?: string;
  message?: string;
  showContact?: boolean;
}

export const NoDataFallback = ({
  showContact = true,
  title = "There are currently no data available.",
  message = "Please check back later or contact us if you have any questions.",
}: NoDataFallbackProps) => {
  const textColor = useColorModeValue("navy.700", "background.100");

  return (
    <Flex
      px="10px"
      minH="60vh"
      align="center"
      justify="center"
      textAlign="center"
      direction="column"
    >
      <Heading color={textColor} fontSize="36px" mb="10px">
        {title}
      </Heading>
      <Text color={textColor} fontSize="md" maxW="600px">
        {message}
        {showContact && <> Contact your studio for more information.</>}
      </Text>
    </Flex>
  );
};
